import Vue from 'vue';
import { ViewerState } from 'viewer/core/instance/ViewerState';
import Viewer from '../../components/ViewerComponent';
import { getVueI18n } from '../../../shared/services/I18nService';

export function startMixin (WebViewer) {
  WebViewer.prototype.start = function start (el) {
    const viewer = this;
    return new Promise(async (resolve, reject) => {
      await this._initPromise;

      return new Vue({
        el,
        i18n: getVueI18n(),
        render: h => h(Viewer, {
          props: {
            viewer,
            onLoad ($vil) {
              viewer.state = new ViewerState($vil);
              resolve($vil);
            }
          }
        }),
        components: { Viewer }
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/viewer/core/instance/start.js